module.exports = __webpack_public_path__ + "img/code.f562fe7b.svg";